/** @format */
import { CategoryTileProps } from '../category-tile';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CategoryBlockVariant {
    MIDNIGHT = 'midnight',
    WHITE = 'white',
}

type BaseCategoryBlockProps = {
    tiles: CategoryTileProps[];
    variant?: CategoryBlockVariant;
};

type Loaded<T> = T & {
    isLoading?: false;
};

type Loading<T> = Partial<T> & {
    isLoading: true;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CategoryBlockProps =
    Loaded<BaseCategoryBlockProps> | Loading<BaseCategoryBlockProps>;

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StyledCategoryBlockProps = Pick<CategoryBlockProps, 'variant'>;
